"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClusteredPickupPointsQuery = void 0;
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _maps = require("../constants/maps");
var _swrConfig = require("../constants/swrConfig");
var _logger = require("../logger");
var _utils = require("../utils");
const hookName = 'useClusteredPickupPointsQuery';
const transformData = data => {
  (0, _logger.logDebug)(`${hookName} hook transformData(): data before transformation:\n\t`, data);
  const rawData = data.collection;
  const result = rawData.filter(({
    coordinates
  }) => Boolean(coordinates)).map(item => {
    const {
      clusterSize,
      coordinates: rawCoordinates,
      pickupPoint
    } = item;
    const coordinates = rawCoordinates;
    const {
      latitude,
      longitude
    } = coordinates;
    const isPickupPoint = Boolean(pickupPoint);
    let key = `${isPickupPoint ? 'pickup-point' : 'cluster'}-marker-${latitude}-${longitude}`;
    key = `${key}-${isPickupPoint ? pickupPoint?.deliveryChannelId : clusterSize}`;
    const displayedClusterSize = Number(clusterSize) > _maps.CLUSTER_SIZE_DISPLAY_LIMIT ? `${_maps.CLUSTER_SIZE_DISPLAY_LIMIT}+` : String(clusterSize ?? '');
    return {
      ...item,
      coordinates,
      displayedClusterSize,
      isPickupPoint,
      key
    };
  });
  (0, _logger.logInfo)(`${hookName} hook: loaded data after transformation:\n\t`, result);
  return result;
};
const useClusteredPickupPointsQuery = params => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const sessionId = (0, _shoppingContext.useSessionId)();
  const {
    searchTerm,
    ...restOfParams
  } = params;
  const {
    east,
    isActive,
    north,
    south,
    west,
    zoom
  } = restOfParams;
  const emptyClusteredPickupPointsDto = {
    collection: []
  };
  const lastLoadedData = (0, _react.useRef)(emptyClusteredPickupPointsDto);
  const headers = (0, _utils.getHeaders)({
    currentLanguage: language,
    tenant
  });
  let transformedClusteringZoom = zoom;
  if (zoom !== undefined) {
    transformedClusteringZoom = Math.ceil(_maps.MAP_MAX_ZOOM - zoom);
  }
  const usedParams = {
    ...restOfParams,
    // add searchTerm only when set to non-empty string, otherwise the API screams
    ...(searchTerm && {
      searchTerm
    }),
    zoom: transformedClusteringZoom
  };
  (0, _logger.logDebug)(`${hookName} hook called, params:`, usedParams);
  const areAllQueryParamsAvailable = east !== undefined && north !== undefined && south !== undefined && west !== undefined && zoom !== undefined;
  const swrOptions = {
    ..._swrConfig.errorHandlingSwrOptions,
    onSuccess: items => {
      (0, _logger.logInfo)(`${hookName} hook: Clustered pickup points data was loaded.`);
      // back up the last loaded data to not delete all pushpins
      // when re-rendering next time while in loading state
      lastLoadedData.current = items;
    },
    enabled: isActive && areAllQueryParamsAvailable
  };
  const {
    data,
    error: clusteredPickupPointsError,
    isValidating
  } = (0, _globalApiClientReact.useGetShoppingSessionClusteredPickupPoints)(sessionId, usedParams, headers, {
    swr: swrOptions
  });
  const clusteredPickupPointsList = transformData(isValidating ? lastLoadedData.current : data ?? emptyClusteredPickupPointsDto);
  return {
    clusteredPickupPointsList,
    clusteredPickupPointsError,
    isClusteredPickupPointsListLoading: isValidating
  };
};
exports.useClusteredPickupPointsQuery = useClusteredPickupPointsQuery;